<template>
  <div>
    <title-edit header="Contact" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" >
        <v-app class="switch-app">
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch </label>
      </v-col>
      <v-col cols="12" sm="8" >
        <select-option :items="optionBranch" :model="form.branch_id"
                       disable
                       @update="updateBranch"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Message </label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.message" disable/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Email </label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.email" disable/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Reply message</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-area :model="form.reply_message" @update="updateReplyMessage"/>
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right" style="margin: 20px">
      <v-spacer></v-spacer>
      <div style="margin-right: 30px">
        <v-btn large @click.native="goToSupportContactTable">Close</v-btn>
      </div>
      <submit-button label="Reply" @click.native="saveSupportContact"/>
    </div>
  </div>
</template>

<script>
    import TitleEdit from "../../../components/TitleHeader/TitleEdit";
    import LineHr from "../../../components/Icon/line-hr";
    import SelectOption from "../../../components/Input/selectOption";
    import InputTextField from "../../../components/Input/InputTextField";
    import DeleteButton from "../../../components/Button/DeleteButton";
    import PreviewButton from "../../../components/Button/PreviewButton";
    import SaveButton from "../../../components/Button/SaveButton";
    import InputEditor from "../../../components/Input/InputEditor";
    import InputImageUpload from "../../../components/Input/InputImageUpload";
    import {mapState} from "vuex";
    import DatePicker from "../../../components/Input/DatePicker";
    import {
      permissionContact, role,
    } from "../../../util/Permission";
    import InputTextArea from "../../../components/Input/InputTextArea";
    import SubmitButton from "../../../components/Button/SubmitButton";
    import Swal from "sweetalert";
    export default {
        name: "SupportContactEdit",
      components: {
        SubmitButton,
        InputTextArea,
        DatePicker,
        InputImageUpload,
        InputEditor,
        SaveButton,
        PreviewButton, DeleteButton, InputTextField,
        SelectOption, LineHr, TitleEdit},
      computed: {
        permissionContact,
        ...mapState({
          form: state => {
            return state.SupportContact.form;
          }
        })
      },
      data(){
        return{
          permission : null,
          optionBranch : [],
        }
      },
      created() {
          this.permission = role;
          this.getBranchData();
      },
      methods:{
        getBranchData() {
          this.$store.dispatch("Branch/getBranchAll").then(res => {
            this.optionBranch = [
              { text: "Select", value: "" },
              ...res.filter(val => val.branch_id !== 0).map(type => ({
                value: type.branch_id,
                text: type.branch_name_th + " (" + type.branch_name_en + ")"
              }))
            ];
          });
        },
        saveSupportContact(){
          this.$store
            .dispatch("SupportContact/saveData", {
              id: this.form.id,
              data: this.form
            })
            .then(res => {
              Swal(res.response_msg);

            })
            .catch(() => {
              Swal('','Cannot reply message!','error');
            });
        },
        deleteSupportContact(){
          this.$store
            .dispatch("SupportContact/deleteData", this.form.id)
            .then(res => {
              Swal(res.response_msg);
              if (res.response_code == 200) {
                this.goToSupportContactTable();
              }
            })
            .catch(() => {
              Swal('','Cannot delete contact support','error');
            });
        },
        goToSupportContactTable(){
          this.$router.push("/customer-support/contact");
        },
        updateBranch(val){
          this.form.branch_id = val;
        },
        updateReplyMessage(val){
          this.form.reply_message = val;
        },
      }
    }
</script>

<style lang="scss" scoped>
  @import "src/assets/css/variables.scss";
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: $cancel-color;
    color: black;
    display: block;
    border-radius: 20px;
    width: $width-button;
    border: 1px solid $cancel-color;
    height: $height-button;
  }
</style>
